import React from 'react';
import { AnimatedIcon } from '@shell-b2c/web-design-system';

export const TickAnimation = (props) => {
  return <AnimatedIcon type="tick" {...props} />;
};

export default TickAnimation;
